// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j_8EL","colBig":"styles_colBig__mjjor","colSmall":"styles_colSmall__1qANl","shopifyNameWrapper":"styles_shopifyNameWrapper__2oZXd"};